import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import DailyComprehensiveRevenue from './DailyComprehensiveRevenue'

const DailyComprehensiveReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Daily Comprehensive Revenue Report" mainTitle="Daily Comprehensive Revenue Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DailyComprehensiveRevenue />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default DailyComprehensiveReport